import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useAuth } from './authContext';
import axios from 'axios';

const ColorContext = createContext();

export const useColors = () => {
  const context = useContext(ColorContext);
  if (!context) {
    throw new Error('useColors must be used within a ColorProvider');
  }
  return context;
};

export const ColorProvider = ({ children }) => {
  const { user } = useAuth();
  const [colors, setColors] = useState({
    primary: '#3B82F6',
    secondary: '#1E40AF'
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user?.email) {
      loadUserColors();
    } else {
      setLoading(false);
    }
  }, [user?.email]);

  const loadUserColors = async () => {
    try {
      console.log('🔄 [COLOR] A carregar cores para:', user.email);
      const response = await axios.get(`/api/ficha-clube-football/${user.email}`);

      if (response.data && response.data.corPrincipal) {
        console.log('✅ [COLOR] Cores carregadas:', response.data.corPrincipal, response.data.corSecundaria);
        setColors({
          primary: response.data.corPrincipal,
          secondary: response.data.corSecundaria
        });
      } else {
        console.log('ℹ️ [COLOR] Nenhuma cor guardada, a usar default');
      }
    } catch (error) {
      console.error('❌ [COLOR] Erro ao carregar cores:', error);
    } finally {
      setLoading(false);
    }
  };

  const updateColors = useCallback((newColors) => {
    console.log('🎨 [COLOR] A atualizar cores localmente:', newColors);
    setColors(newColors);
  }, []);

  const value = React.useMemo(() => ({
    colors,
    updateColors,
    loading
  }), [colors, updateColors, loading]);

  return (
    <ColorContext.Provider value={value}>
      {children}
    </ColorContext.Provider>
  );
};
